import axios from "axios";
import { hftApi } from "../../constants/apis/clinic_apis";
import { getUserToken } from "../../utils/localStoarege";

export const getHfts = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(hftApi, config);
    return response;
};
